import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Alert, Col, Container, Row } from 'react-bootstrap';

import TenantContext from '../../hoc/Context/TenantContext';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FormBuilder from '../../components/Form/FormBuilder/FormBuilder';
import '../../style/accessibleView.scss';
import { configResource, circulationResource, reCaptchaResource } from '../../resource';
import _ from 'lodash';

/**
 * Container for registration
 * - load institution information
 * - load Google reCaptcha keys
 * - load fields of form configs
 * - load form config (group and field sort) in current locale
 * - show errors
 */

const headerTitle = 'header.registration.title';

class Registration extends Component {
  state = {
    accessibleView: false
  };

  componentDidMount() {
    const { intl, tenant, locale } = this.props;

    const configs = [
      circulationResource.getInstitutionInformation(tenant, locale),
      reCaptchaResource.getRecaptchaKey(tenant, locale),
      configResource.getFieldsConfig(),
      configResource.getFormConfig(),
      circulationResource.getUploadLimitations(tenant),
      circulationResource.getTenantFormFields(tenant, locale)
    ];

    Promise.all(configs)
      .then(responses => {
        const [
          institutionInformation,
          reCaptchaConfig,
          fieldConfig,
          formConfig,
          fileUploadLimitations,
          huntekaConfig
        ] = responses;

        const filteredFormConfig = this.filterConfigSource(formConfig, locale, huntekaConfig);

        this.setState({
          fieldConfig,
          formConfig: filteredFormConfig,
          recaptchaSiteKey: reCaptchaConfig.entity,
          headerTitle: `${institutionInformation.name} - ${intl.formatMessage({
            id: headerTitle
          })}`,
          fileUploadLimitations,
          huntekaConfig
        });
      })
      .catch(err => {
        console.error('Failed to initialize the registration form', err);
        this.setState({
          error: true
        });
      });
  }

  errorHandler = error => {
    console.error(error);
    this.setState({
      error: true
    });
  };

  changeView(isChanged) {
    this.setState({
      accessibleView: isChanged
    });
  }

  filterConfigSource = (formConfig, locale, huntekaConfig) => {
    const filteredFormConfig = _.merge(
      formConfig.base,
      formConfig.languageSpecific[locale.language] || {}
    );
    if (huntekaConfig) {
      for (let i = 0; i < filteredFormConfig.groups.length; i++) {
        filteredFormConfig.groups[i].fields = filteredFormConfig.groups[i].fields.filter(field => {
          const fieldNormalized = new RegExp(field, "i");
          return huntekaConfig.allowedFields.some(allowedField =>
            fieldNormalized.test(allowedField)
          );
        });
      }
    }
    return filteredFormConfig;
  };

  render() {
    const { intl, tenant, locale } = this.props;
    const {
      fieldConfig,
      formConfig,
      recaptchaSiteKey,
      error,
      fileUploadLimitations,
      huntekaConfig
    } = this.state;
    const tenantInfo = { tenant, locale };
    const title = intl.formatMessage({ id: headerTitle });
    return (
      <div className={this.state.accessibleView ? 'accessibleView' : ''}>
        <Header
          title={title}
          changeView={this.changeView.bind(this)}
          huntekaConfig={huntekaConfig}
        />
        <Container id="main">
          <Row>
            <Col xs="10" className="mx-auto">
              {!error && fieldConfig && formConfig ? (
                <TenantContext.Provider value={tenantInfo}>
                  <FormBuilder
                    config={formConfig}
                    fields={fieldConfig}
                    recaptchaSiteKey={recaptchaSiteKey}
                    errorHandler={this.errorHandler}
                    fileUploadLimitations={fileUploadLimitations}
                    huntekaConfig={huntekaConfig}
                  />
                </TenantContext.Provider>
              ) : null}
              {error ? (
                <Alert variant="danger">
                  <FormattedMessage id="error.loadFormConfig" />
                </Alert>
              ) : null}
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default injectIntl(Registration);
